import { getAddressData, validateTextWithHypen, } from '@/utils';
export default class StoreAdjustment {
    _storeId;
    _storeName;
    _businessNumber;
    _ceoName;
    _businessCondition;
    _businessType;
    _ceoEmail;
    _orderCount;
    _totalAmount;
    _businessName;
    siDo;
    siGunGu;
    eupMyeonDong;
    li;
    jibun;
    roadName;
    buildingNumber;
    buildingName;
    addressDetail;
    addressSiDo;
    addressSiGunGu;
    addressDong;
    addressLi;
    addressJibun;
    addressRoad;
    addressBuildingNumber;
    addressBuildingName;
    constructor({ storeId: _storeId, storeName: _storeName, businessNumber: _businessNumber, ceoName: _ceoName, businessCondition: _businessCondition, businessType: _businessType, ceoEmail: _ceoEmail, orderCount: _orderCount, totalAmount: _totalAmount, businessName: _businessName, ..._store }) {
        Object.assign(this, {
            ..._store,
            _storeId,
            _storeName,
            _businessNumber,
            _ceoName,
            _businessCondition,
            _businessType,
            _ceoEmail,
            _orderCount,
            _totalAmount,
            _businessName,
        });
    }
    get storeId() {
        return this._storeId;
    }
    get storeName() {
        return validateTextWithHypen(this._storeName);
    }
    get validatedBusinessNumber() {
        return validateTextWithHypen(this._businessNumber);
    }
    get validatedCeoName() {
        return validateTextWithHypen(this._ceoName);
    }
    get validatedBusinessCondition() {
        return validateTextWithHypen(this._businessCondition);
    }
    get validatedBusinessType() {
        return validateTextWithHypen(this._businessType);
    }
    get validatedCeoEmail() {
        return validateTextWithHypen(this._ceoEmail);
    }
    get orderCount() {
        return this._orderCount;
    }
    get totalAmount() {
        return Math.floor(this._totalAmount);
    }
    get validatedBusinessName() {
        return validateTextWithHypen(this._businessName);
    }
    /**
     * 사업장 주소
     * @returns {string}
     */
    getStoreAddress() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, road, detail, } = getAddressData({
            inSiDo: this.siDo,
            inSiGunGu: this.siGunGu,
            inEupMyeonDong: this.eupMyeonDong,
            inLi: this.li,
            inJibun: this.jibun,
            inRoad: this.roadName,
            inBuildingNumber: this.buildingNumber,
            inBuildingName: this.buildingName,
            inDetail: this.addressDetail,
        });
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            road,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * BusinessInfo 사업장주소
     */
    get businessInfoAddress() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, road, detail, } = getAddressData({
            inSiDo: this.addressSiDo,
            inSiGunGu: this.addressSiGunGu,
            inEupMyeonDong: this.addressDong,
            inLi: this.addressLi,
            inJibun: this.addressJibun,
            inRoad: this.addressRoad,
            inBuildingNumber: this.addressBuildingNumber,
            inBuildingName: this.addressBuildingName,
            inDetail: this.addressDetail,
        });
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            road,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
}
